<template>
  <!--隐藏的分享-->
  <div class="shadow_nr" v-show="shareBox" v-on:click="cancelshareBox(false)" style="z-index: 999;">
    <transition name="pull-up">
      <div class="shadow-cont" v-on:click="clickTest" v-show="shareShow">
        <div class="share-list fx-bjf8">
          <ul class="clear">
            <li @click="shareWxFriends">
              <p class="item-con i1"></p>
              <p class="item-text">WeChat</p>
            </li>
            <li @click="shareWxCircle">
              <p class="item-con i2"></p>
              <p class="item-text">モーメンツ</p>
            </li>
            <!-- <li @click="shareQQ">
              <p class="item-con i3"></p>
              <p class="item-text">QQ</p>
            </li>
            <li @click="shareQzone">
              <p class="item-con i4"></p>
              <p class="item-text">QQ空间</p>
            </li> -->
            <!-- <li @click="shareSina">
              <p class="item-con i10"></p>
              <p class="item-text">新浪微博</p>
            </li> -->
            <li @click="shareFacebook">
              <p class="item-con i12"></p>
              <p class="item-text">Facebook</p>
            </li>
            <li @click="shareTwitter">
              <p class="item-con i13"></p>
              <p class="item-text">Twitter</p>
            </li>
            <!-- <li @click="shareLine">
              <p class="item-con i14"></p>
              <p class="item-text">Line</p>
            </li>
            <li @click="shareEmail">
              <p class="item-con i15"></p>
              <p class="item-text">邮件</p>
            </li> -->
          </ul>
        </div>
        <div class="share-list fx-bjf8">
          <ul class="clear">
            <!-- <li v-if="removeIcon" @click="deleteItem">
              <p class="item-con i9"></p>
              <p class="item-text red">删除</p>
            </li> -->
            <li v-if="!favorateIcon" @click="favorateItem">
              <p class="item-con i5"></p>
              <p class="item-text">お気に入り</p>
            </li>
            <li v-if="favorateIcon" @click="favorateCancel">
              <p class="item-con i5"></p>
              <p class="item-text">お気に入りを削除</p>
            </li>
            <li v-if="reportIcon && !blockIcon" @click="blockItem">
              <!-- <p class="item-con i5"></p> -->
              <img src="@/assets/images/hmd2.png" style="width: 65px;height:65px;"/>
              <p class="item-text">阻止リスト</p>
            </li>
            <!--<li>-->
            <!--<p class="item-con i6"></p>-->
            <!--<p class="item-text">只看楼主</p>-->
            <!--</li>-->
            <li v-if="reportIcon" @click="reportItem">
              <p class="item-con i7"></p>
              <p class="item-text">通報</p>
            </li>
            <!-- <li v-if="reverseIcon" @click="reverseComment">
              <p class="item-con i8"></p>
              <p class="item-text">排列の変更</p>
            </li> -->
            <!-- <li v-if="reverseIcon" @click="blockArticle">
              <img src="@/assets/images/hmd1.png" style="width: 65px;height:65px;"/>
              <p class="item-text">黒っぽい文章を書く</p>
            </li> -->
          </ul>
        </div>
        <div class="cancel" @click="cancelshareBox(false)">キャンセル</div>
      </div>
    </transition>
  </div>

</template>


<script>
  import { post , uploadPost } from '@/assets/js/json'
  import router from '@/router'
  import deepCopy from 'json-deep-copy'
  import { getShareService, showLoading, closeLoading } from '@/assets/js/native'
  import { openUrls } from '@/assets/js/util'

  export default {
    data () {
      return {
        shareBox: false,
        favorateIcon: false,
        removeIcon: false,
        reverseIcon: false,
        reportIcon: false,
        blockIcon: false,
        comment: [],
        item: {},
        type: 'article',
        shareMessage: {},
        shareShow: false,
        share_url: "www.horamite.com",
        share_title: "horamite"
      }
    },
    methods: {
      cancelshareBox (val) {
        if (!val) {
          this.shareShow = val
          setTimeout(() => {
            this.shareBox = val
          }, 300)
        } else {
          this.shareShow = val
          this.shareBox = val
        }
      },
      clickTest (e) {
        e.stopPropagation()
      },
      reverseComment () {
        if (this.comment && this.comment.length > 0) {
          this.comment.reverse()
        }
        this.shareBox = false
      },
      blockItem () {
        if (this.item && this.item.id) {
            this.$confirm({title:'確認',content:'阻止リストに入れますか？',yesText:'はい',noText:'キャンセル'}).then(() => {
              let option = {}
              if(this.type == 'article'){
                option = {
                  'targetId': this.item.id,
                  'type': 'ARTICLE_BLACK'
                }
              }else if(this.type == 'post'){
                option = {
                  'targetId': this.item.id,
                  'type': 'POST_BLACK'
                }
              }else{
                option = {
                  'targetId': this.item.id,
                  'type': 'MEMBER_BLACK'
                }
              }
              let config = {
                headers: {'Content-Type': 'application/json'}
              }
              console.log(option)
              uploadPost('/api/member/blacklist/add',option,config).then((res) => {
                if (res.data.success) {
                  this.$tips('黒を引く成功')
                  this.shareBox = false
                }
              })
            })
        }
      },
      deleteItem () {
        if (this.item && this.item.id) {
          this.$confirm('本当に削除しますか？').then(() => {
            if (this.type === 'article') {
              const option = {
                'id': this.item.id
              }
              post('/api/member/article/delete', option).then((res) => {
                if (res.data.success) {
                  router.back()
                }
              })
            } else if (this.type === 'post') {
              const option = {
                'postId': this.item.id
              }
              // this.$bus.$emit('deleteDynamic', this.item.id)
              // router.back()
              post('/api/member/post/delete', option).then((res) => {
                if (res.data.success) {
                  this.$bus.$emit('deleteDynamic', this.item.id)
                  router.back()
                }
              })
            }
          })
        }
        this.shareBox = false
      },
      favorateItem () {
        if (this.item && this.item.id) {
          if (this.type === 'article') {
            const option = {
              'articleId': this.item.id
            }
            post('/api/member/article/favorite/add', option).then((res) => {
              if (res.data.success) {
                this.$tips('お気に入りに登録')
                this.favorateIcon = true
                this.$bus.$emit('favorateIconChange', this.favorateIcon)
              }
            })
          } else if (this.type === 'post') {
            const option = {
              'postId': this.item.id
            }
            post('/api/member/post/favorite/add', option).then((res) => {
              if (res.data.success) {
                this.$tips('お気に入りに登録')
                this.favorateIcon = true
                this.$bus.$emit('favorateIconChange', this.favorateIcon)
              }
            })
          }
        }
        this.shareBox = false
      },
      favorateCancel () {
        if (this.item && this.item.id) {
          if (this.type === 'article') {
            const option = {
              'articleId': this.item.id
            }
            post('/api/member/article/favorite/delete', option).then((res) => {
              if (res.data.success) {
                this.$tips('お気に入りを取消')
                this.favorateIcon = false
                this.$bus.$emit('favorateIconChange', this.favorateIcon)
              }
            })
          } else if (this.type === 'post') {
            const option = {
              'postId': this.item.id
            }
            post('/api/member/article/favorite/delete', option).then((res) => {
              if (res.data.success) {
                this.$tips('お気に入りを取消')
                this.favorateIcon = false
                this.$bus.$emit('favorateIconChange', this.favorateIcon)
              }
            })
          }
        }
        this.shareBox = false
      },
      reportItem () {
        if (this.item && this.item.id) {
          if (this.type === 'article') {
            router.push(`/error?articleId=${this.item.id}`)
          } else if (this.type === 'post') {
            router.push(`/post-report?postId=${this.item.id}`)
          } else {
            router.push(`/user-report?uid=${this.item.id}`)
          }
        }
        this.shareBox = false
      },
      shareWxFriends () {
        post('/api/member/profile/check_is_login').then((res) => {
          if (!res.data.data.isLogin) {
            router.push("/login")
          }else{
            const shareMessage = deepCopy(this.shareMessage)
            shareMessage.extra = {
              scene: 'WXSceneSession'
            }
            showLoading()
            getShareService('weixin', shareMessage)
            setTimeout(() => {
              closeLoading()
              //plus.nativeUI.showWaiting('暫定的に使用できない機能です...')
            }, 1000)
          }
        })
      },
      shareWxCircle () {
        post('/api/member/profile/check_is_login').then((res) => {
          if (!res.data.data.isLogin) {
            router.push("/login")
          }else{
            showLoading()
            const shareMessage = deepCopy(this.shareMessage)
            shareMessage.extra = {
              scene: 'WXSceneTimeline'
            }
            getShareService('weixin', shareMessage)
            setTimeout(() => {
              closeLoading()
              //plus.nativeUI.showWaiting('暫定的に使用できない機能です...')
            }, 1000)
          }
        })
      },
      shareQQ () {
        showLoading()
        getShareService('qq', this.shareMessage)
        setTimeout(() => {
          closeLoading()
        }, 1000)
      },
      shareQzone () {
        showLoading()
        getShareService('qq', this.shareMessage)
        setTimeout(() => {
          closeLoading()
        }, 1000)
      },
      shareSina () {
        this.shareMessage.content = this.shareMessage.title + this.shareMessage.href
        delete this.shareMessage.href
        getShareService('sinaweibo', this.shareMessage)
        setTimeout(() => {
          closeLoading()
          plus.nativeUI.showWaiting('暫定的に使用できない機能です...')
        }, 1000)
      },
      /*shareFacebook () {
        console.log(111111111111)
        FB.init({
        appId: '你的appid',
        autoLogAppEvents: true,
        xfbml: true,
        version: "v2.12"
        });
        FB.ui(
          {
          method: "share",
          mobile_iframe: true,
          href: "http://dev.XXXX.io/?test=12345"
          },
          function(response) {}
        );
      },*/
      shareTwitter() {
        post('/api/member/profile/check_is_login').then((res) => {
          if (!res.data.data.isLogin) {
            router.push("/login")
          }else{
            // plus.nativeUI.toast('请稍等')
            function popupwindow(url, title) {
              return window.open(
                "https://twitter.com/intent/tweet?url=" +
                  encodeURIComponent(url) +
                  "&text=" +
                  encodeURIComponent(title),
                "_parent",
                "toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350"
              );
            }
            popupwindow(this.shareMessage.href, this.shareMessage.content);
            /*let item = {
              url:"https://twitter.com/intent/tweet?url="+encodeURIComponent(this.share_url),
              urlTitle: "ces"
            }
            openUrls(item)*/
          }
        })
      },
      shareLine() {
        plus.nativeUI.toast('暫定的に使用できない機能です...')
      },
      shareEmail() {
        plus.nativeUI.toast('暫定的に使用できない機能です...')
      },
      // 分享到脸书
      shareFacebook() {
        post('/api/member/profile/check_is_login').then((res) => {
          if (!res.data.data.isLogin) {
            router.push("/login")
          }else{
            plus.nativeUI.toast('请稍等')
            function popupwindow(url, title) {
              return window.open(
                "http://www.facebook.com/sharer.php?u=" +
                  encodeURIComponent(url),
                  //  +
                  // +"&t=" +
                  // encodeURIComponent(title),
                "_self",
                "toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350"
              );
            }
            popupwindow(this.shareMessage.href, this.shareMessage.content);
          }
        })
      },
    }
  }
</script>

<style lang="less" scoped>
  .share-list {
    padding: 10px 0px;
    overflow-x: scroll;
    white-space: nowrap;
    font-size: 0px;
  }

  .share-list:first-child {
    border-bottom: 1px solid #eee;
  }

  .share-list ul {
    overflow-x: scroll;
    white-space: nowrap;
    font-size: 0px;
  }

  .share-list ul li {
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    outline: none;
    width: 22.5%;
  }

  .share-list ul li .item-con {
    margin: 0px auto;
    height: 65px;
    width: 65px;
    background: url(~src/assets/images/share-tb2.png) no-repeat;
    background-size: 700px auto;
    display: inline-block;
    vertical-align: middle;
  }

  .share-list ul li .red {
    color: #de2717 !important;
  }

  .share-list ul li .i1 {
    background-position: -2px 0 !important;
  }

  .share-list ul li .i2 {
    background-position: -81px 0 !important;
  }

  .share-list ul li .i3 {
    background-position: -159px 0 !important;
  }

  .share-list ul li .i4 {
    background-position: -238px 0 !important;
  }

  .share-list ul li .i10 {
    background-position: -317px 0 !important;
  }

  .share-list ul li .i12 {
    background-position: -396px 0 !important;
  }

  .share-list ul li .i13 {
    background-position: -475px 0 !important;
  }

  .share-list ul li .i14 {
    background-position: -554px 0 !important;
  }

  .share-list ul li .i15 {
    background-position: -633px 0 !important;
  }

  .share-list ul li .i5 {
    background-position: -2px -80px !important;
  }

  .share-list ul li .i6 {
    background-position: -81px -80px !important;
  }

  .share-list ul li .i7 {
    background-position: -159px -80px !important;
  }

  .share-list ul li .i8 {
    background-position: -238px -80px !important;
  }

  .share-list ul li .i9 {
    background-position: -382px -80px !important;
  }

  .share-list ul li .item-text {
    height: 25px;
    line-height: 25px;
    font-size: 12px;
    color: #333;
  }

</style>



// WEBPACK FOOTER //
// src/components/base/share/share.vue